import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SystemStoreFacadeService } from '../store/system-store-facade.service';
import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';
import * as moment from 'moment';
import { DateAdapter } from '@angular/material/core';

@Injectable()
export class IpsTranslateService {
  constructor(
    public translate: TranslateService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    private readonly store: StoreService,
    @Inject(DOCUMENT) private readonly document: Document,
    private dateAdapter: DateAdapter<any>,
  ) {}

  init(defaultLocale?: string) {
    // Set default language
    const initialLocale = defaultLocale ?? 'en';
    this.translate.setDefaultLang(initialLocale);

    // Subscribe to locale changes
    this.systemStoreFacade.getLocale().subscribe(locale => {
      if (!locale) return;

      // Update document language
      this.document.documentElement.lang = locale;

      // Set translation language
      this.translate.use(locale).subscribe();

      // Store locale in session/store
      this.store.setLocale(locale);

      // Update Moment.js
      moment.locale(this.getMomentLocale(locale));

      // Update Angular Material datepicker
      this.dateAdapter.setLocale(this.getMatLocale(locale));

    });
  }

  // Map to Angular Material locales
  private getMatLocale(locale: string): string {
    if (locale.startsWith('pt')) return 'pt-PT';
    if (locale.startsWith('es')) return 'es-ES'; // use standard Angular Material locale
    return 'en-US';
  }

  // Map to Moment.js locales
  private getMomentLocale(locale: string): string {
    if (locale.startsWith('pt')) return 'pt';
    if (locale.startsWith('es')) return 'es'; 
    return 'en';
  }
}
